<template>
    <el-dialog
        class="set-private"
        :visible.sync="batchChangeVisible"
        :close-on-click-modal="false"
        @closed="closeDialog"
        width="500px"
        title="Batch Change"
        :lock-scroll="false"
        :modal-append-to-body="false"
        append-to-body
    >
        <div class="container">
            <el-form
                ref="userForm"
                :model="userForm"
                :rules="rules"
            >
                <el-row>
                    <el-col :span="24">
                         <el-link type="primary">Selected：{{selectEmailLen}}</el-link>
                    </el-col>   
                    <el-col :span="24">
                        <el-form-item label="Email" prop="email" size="small">
                            <el-input
                                type="textarea"
                                v-model="userForm.email"
                                :autosize="{ minRows: 5, maxRows: 10 }"
                                placeholder="Please input email"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item
                            label="Business Code"
                            prop="business_code"
                            size="small"
                        >
                           <el-select
                            v-model="userForm.business_code"
                            clearable
                            filterable
                            size="small"
                            placeholder="Please select business code"
                        >
                            <el-option
                                :label="item.business"
                                :value="item.code"
                                v-for="item of businessCodeList"
                                :key="item.code"
                            ></el-option>
                        </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="Delivery Tag" prop="delivery_tag" size="small">
                            <el-input
                                v-model="userForm.delivery_tag"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button size="small" type="primary" @click="save"
                >Save</el-button
            >
            <el-button size="small" @click="batchChangeVisible = false"
                >Close</el-button
            >
        </span>
    </el-dialog>
</template>

<script>
import { cmofferApi } from "@/http/cmofferApi.js";
import { mapActions } from "vuex";
export default {
    
    data() {
        let checkDelivery = (rule, value, callback) => {
            if (value == '' && this.userForm.delivery_tag == '') {
                return callback(new Error("二者必填其一"));
            } else {
                callback();
            }
        };
        return {
            userForm: {
                email: "",
                business_code: "",
                delivery_tag:""
            },
            businessCodeList:[],
            selectEmailLen:0,
            rules: {
                email: [
                    {
                        required: true,
                        trigger: "blur",
                    },
                ],
                business_code: [
                    {
                        required: true,
                        //validator: checkDelivery,
                        trigger: "blur",
                    },
                ],
            }
        };
    },
    methods: {
        ...mapActions(["getBusinessCodeSelect"]),
        closeDialog() {
            this.userList = [];
            this.$refs["userForm"].clearValidate();
            this.$refs["userForm"].resetFields();
            this.$emit("update:batchChangeVisible", false);
        },
        save() {
            this.$refs["userForm"].validate((valid) => {
                if (valid) {
                    this.loading = true;
                    cmofferApi
                        .changeBusinessCodeAndDeliveryTag(
                            {
                                business_code: this.userForm.business_code,
                                email: this.userForm.email.split("\n"),
                                delivery_tag: this.userForm.delivery_tag
                            },
                            "post"
                        )
                        .then((res) => {
                            if (res) {
                                if(res.errmsg != 'ok'){
                                    this.$message.warning({
                                        dangerouslyUseHTMLString: true,
                                        message: res.errmsg,
                                        showClose: true,
                                        duration: 3000
                                    });
                                }else{
                                    this.$message.success("Success!");
                                    this.$parent.saleUserList(1);
                                    this.closeDialog();
                                } 
                            }
                        })
                        .catch(() => {
                            this.loading = false;
                        });
                }
            })
            
        },
    },
    props: {
        batchChangeVisible: Boolean,
        emailList:Array,
    },
    watch: {
        batchChangeVisible(val) {
            this.getBusinessCodeSelect().then((res) => {
                this.businessCodeList = res.data;
            });
            this.userForm.email = '';
            this.selectEmailLen = 0;
            if(this.emailList.length > 0){
                this.selectEmailLen = this.emailList.length;
                for (var i = 0; i < this.emailList.length; i++) { 
                    this.userForm.email += this.emailList[i] + "\n";
                }
            }
        },
    },
};
</script>
<style lang="scss" scoped>
.set-private {
    .container {
        .el-select--small {
            width: 100%;
        }
    }
}
</style>
